export default class SvgElement {
    /** @param {Element} domElement */
    constructor(domElement) {
        this._domElement = domElement;
    }

    /** @return {string | null} */
    getId() {
        return this._domElement.getAttribute('id')
    }

    /**
     * @return {SvgElement}
     */
    attr(name, value) {
        // if(value === undefined || Number.isNaN(value))
        //     throw new Error(value);
        this._domElement.setAttribute(name, value);
        return this;
    }

    /**
     * @return {SvgElement}
     */
    style(name, value) {
        this._domElement.style[name] = value;
        return this;
    }

    /**
     * @return {SvgElement}
     */
    text(text) {
        this._domElement.textContent = text;
        return this;
    }

    /** @param {string} className */
    addClass(className) {
        this._domElement.classList.add(className)
    }

    /** @param {string} className */
    removeClass(className) {
        this._domElement.classList.remove(className)
    }

    getAttr(name) {
        return this._domElement.getAttribute(name)
    }

    setVisible(isVisible) {
        this.style('display', isVisible ? null : 'none');
        return this;
    }

    /**
     * Reinserts underlying svg-element as the first child of its parent
     * @return {SvgElement}
     */
    asFirstChild() {
        const parentNode = this._domElement.parentNode;
        if (this._domElement.previousSibling)
            parentNode.insertBefore(this._domElement, parentNode.firstChild);
        return this;
    }

    asLastChild() {
        if (this._domElement.nextSibling)
            this._domElement.parentNode.appendChild(this._domElement);
    }

    /**
     * Removes element itself
     */
    remove() {
        this._domElement.remove()
    }

    on(event, cb){
        this._domElement.addEventListener(event, cb);
        return this;
    }

    domElement() {
        return this._domElement;
    }
}
